import styled from 'styled-components';

import Card from '../../Card';


export const StyledCard = styled(Card)`
  display: grid;

  grid-row-gap: 20px;

  h3 {
    font-style: unset;
  }
`;

export const Row = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  text-align: center;

  &.cols-1 {
    grid-template-columns: 1fr;
  }

  &.cols-2 {
    grid-template-columns: repeat(2, 1fr);
  }

  &.cols-3 {
    grid-template-columns: repeat(3, 1fr);

    p {
      margin: 0;
    }
  }

  button, .button:focus {
    width: 50%;
    outline: none;
    margin: 10px 25%;
  }
  @media all and (min-width: 993px) and (max-width: 1200px) {
    width: 50%;
   }
`;

export const CourseStat = styled.div`
  p {
    margin: 14px 0;
    color: #b5f92d;
    font-size: 30px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/DataCentre/CoursePicker/CoursePicker.styles.ts